import React from 'react';
import _ from 'underscore';
import { compose } from 'recompose';

import { goToDashboardUser } from '../components/GoToPage';
import SessionStorage from '../components/SessionStorage';
import { withFormUtils } from '../components/Misc/forms';

import { withClient } from './Misc/client';

const session = new SessionStorage();

class Profile extends React.Component {
    constructor(props) {
        super(props);

        this.props = props;
        this.handleClick = this.handleClick.bind(this);
        this.loadLogo = this.loadLogo.bind(this);
    }

    componentDidMount() {
        this.loadLogo();
    }

    componentDidUpdate(prevProps) {
        const currentClient = this.props.client || {};
        const prevClient = prevProps.client || {};
        if (currentClient.error !== prevClient.error && prevClient.error) {
            this.props.showErrorForm({
                message: currentClient.error,
                onOk: () => {
                    this.props.hideForm();
                },
            });

            return;
        }
    }

    handleClick() {
        goToDashboardUser();
    }

    loadLogo() {
        const sessionClient = session.getClient();
        if (_.isEmpty(sessionClient)) {
            this.props.getCurrentClient();
        }
    }

    render() {
        const sessionClient = session.getClient();
        const { client = {} } = this.props;
        const logo = client.logo || sessionClient.logo;

        return (
            <div className="client__header" onClick={this.handleClick}>
                {logo && <img className="client__logo" src={logo} />}
            </div>
        );
    }
}

export default compose(
    withClient,
    withFormUtils,
)(Profile);
